var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('TopVedio'),_vm._v(" "),_c('SmartDoor'),_vm._v(" "),_c('MeetingRoom'),_vm._v(" "),_c('Content'),_vm._v(" "),_c('NovoGotop'),_vm._v(" "),_c('NovoFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab73bf9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/index.vue
// module id = null
// module chunks = 